package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.allergens_tab.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.WeightEvaluationTypeEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.jetbrains.compose.web.attributes.InputType

@Composable
fun CreateCustomAllergeneDialog(
    createCustomAllergeneLoading:Boolean,
    onCancelClick:()->Unit,
    createCustomAllergen:(String, String, String, String)->Unit,
)
{
    val selectedWeightEvaluationType= remember {
        mutableStateOf<WeightEvaluationTypeEnum?>(null)
    }
    val keyword = remember { mutableStateOf("") }
    val number = remember { mutableStateOf("") }
    val name = remember { mutableStateOf("") }
    
    val isFormValid = keyword.value.isNotEmpty() && 
                      number.value.isNotEmpty() && 
                      name.value.isNotEmpty() && 
                      selectedWeightEvaluationType.value != null

    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onCancelClick()
            }
    ){
        Column(
            modifier = Modifier
                .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                }
                .align(Alignment.Center)
                .width(Dimen.createCustomAlergeneDialogWidth)
                .height(Dimen.createCustomAlergeneDialogHeight)
                .backgroundColor(Theme.White.rgb)
                .boxShadow(
                    color = Theme.ActionDisabledBackground.rgb,
                    blurRadius = Dimen.smallBlurRadius,
                )
                .borderRadius(r= Dimen.semiLargeRadius),
            horizontalAlignment = Alignment.Start
        ){

            DialogTitle(
                title = Strings.current().createCustomeAlergene,
                showCloseIcon = true,
                showSeparator = false,
                onCloseClick = {
                    onCancelClick()
                }
            )

            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(Dimen.extraLargePadding)
            )
            {
                CustomEditText(
                    label = Strings.current().name,
                    fillMaxWidth = true,
                    value = name.value,
                    onFocusOut = {},
                    onFocusIn = {},
                    onInputChange = {newValue, validation ->
                        name.value = newValue
                    },

                )

                CustomEditText(
                    label = Strings.current().keyword,
                    fillMaxWidth = true,
                    value = keyword.value,
                    onFocusOut = {},
                    onFocusIn = {},
                    onInputChange = {newValue, validation ->
                        keyword.value = newValue
                    },

                )

                DropDownItem(
                    modifier = Modifier.margin(bottom = Dimen.highLargePadding) ,
                    label =Strings.current().unit ,
                    fillMaxWidth = true,
                    options = WeightEvaluationTypeEnum.entries,
                    displayText = {
                        if (it is WeightEvaluationTypeEnum)
                            it.title
                        else ""
                    },
                    selectedItem = selectedWeightEvaluationType.value,
                    onOptionClick = {
                        if (it is WeightEvaluationTypeEnum)
                            selectedWeightEvaluationType.value=it
                    },

                )

                CustomEditText(
                    label = Strings.current().number,
                    fillMaxWidth = true,
                    value = number.value,
                    isDecimal = true,
                    onFocusOut = {},
                    onFocusIn = {},
                    usingDotForDigit = true,
                    onInputChange = {newValue, validation ->
                        number.value = newValue
                    },

                )



                Spacer()

                Row(
                    Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center
                )
                {
                    CustomButton(
                        modifier = Modifier
                            .margin(
                                right = Dimen.mediumPadding
                            ),
                        title = Strings.current().cancel,
                        buttonType = ButtonTypes.TEXT,
                        onButtonClick ={
                            onCancelClick()
                        },

                    )

                    CustomButton(
                        isClickable = isFormValid,
                        title = Strings.current().confirm,
                        loading = createCustomAllergeneLoading,
                        buttonType = ButtonTypes.CONTAINED,
                        onButtonClick = {
                            val nameValue = name.value
                            val unitValue = selectedWeightEvaluationType.value?.value ?: ""
                            val numberValue = number.value
                            val keywordValue = keyword.value
                            
                            createCustomAllergen(
                                nameValue,
                                unitValue,
                                numberValue,
                                keywordValue
                            )
                        },
                    )
                }
            }

        }
    }


}